import { render } from "./StartMenu.vue?vue&type=template&id=619a8cff&scoped=true"
import script from "./StartMenu.vue?vue&type=script&lang=js"
export * from "./StartMenu.vue?vue&type=script&lang=js"

import "98.css?vue&type=style&index=0&lang=css"
import "./StartMenu.vue?vue&type=style&index=1&id=619a8cff&scoped=true&lang=css"

import exportComponent from "/home/runner/work/oliverclark15.github.io.source/oliverclark15.github.io.source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619a8cff"]])

export default __exports__